import React from "react";

function GrandJeux(props) {
  return (
    <div>
      <h1>Temps de grands jeux en bois</h1>

      <p>
        Nous choisissons une vingtaine de grands jeux en bois pour tout âge et
        faisant appel aux sens, à la stratégie, à la rapidité, à la coopération,
        à l&#8217;adresse…{" "}
      </p>

      <p>Adapté aux enfants à partir de 6 ans jusqu&#8217;à 106 ans! </p>

      <p></p>

      <p></p>

      <p>
        Un animateur de LudoBlue installe le cadre ludique et sont présents
        tout au long du «temps de jeux» pour accompagner les petits et les
        grands, dans leurs choix de jeux, la pratique de ceux-ci et
        l’explication des règles. A ce titre, ils seront responsables du bon
        déroulement de l’activité ludique.
      </p>

      <div>
     
        
      </div>
    </div>
  );
}

export default GrandJeux;
